import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvrbfcvnnx: FaireProductEntity = {
  token: "p_jvrbfcvnnx",
  type: "product",
  name: "Home Decor -Buddha -Ornament",
  brandToken: "b_3tsmjrbcyw",
  brandName: "Arômes & Évasions (Cayves Wholesale)",
  imageUrl:
    "https://cdn.faire.com/fastly/4ac7621af31072ac86992f3667d4c70472b2e165aa6e351f68177e56186cb6ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fec18b8f1614ea8bf3f7dc275030b2677f79ea08ed27e8542a9c54ba757270b3.jpeg",
    "https://cdn.faire.com/fastly/19b48e064cbaa4b06bf65ddb3add8f5831f2039473756f0fb081537c4e7e4c61.jpeg",
    "https://cdn.faire.com/fastly/2a07b0a9d08c21999490bfdbcb9cffc2216d23a4b8bcca61a4f04f44b52b7d8e.jpeg",
    "https://cdn.faire.com/fastly/89e1fa16410f2bb19622b8124f747f56f16ef3e1dc0fed6fcb34f54b6d4a46e3.jpeg",
    "https://cdn.faire.com/fastly/de85147833a971d459257481457d4e83ee3cf79fb08902058a67e298b5426134.jpeg",
    "https://cdn.faire.com/fastly/ede6580ad1206f924b04c7647a511f0e5bdd8b0e93877443b219c6d6fb5611f5.jpeg",
  ],
  priceDollars: 5.5,
  description:
    'Bring Peace and Serenity to Your Home with Our Resin Buddha Ornament\n\nLooking to add some zen vibes to your home decor? Look no further than this adorable Buddha ornament!\n\nMade of high-quality resin, this little guy stands at a height of 1.5" to 2.5", making it the perfect size to place on your shelf, desk, or anywhere else that could use a touch of tranquility.\n\nThe best part? This little Buddha is sure to bring a smile to your face every time you see it. Whether you\'re a dedicated yogi or just someone who appreciates a good dose of positivity, this ornament is a must-have for your home. And with its charming design, it\'s a great conversation starter for when you have guests over.\n\n There are 6 distinct Buddha styles available for selection.\n\nPlease note: due to the nature of the manufacturing process, the color of the ornament may vary slightly, but that just adds to its unique charm! So go ahead, bring a little peace and serenity into your home with this delightful Buddha ornament.\n\nSKU: 127438357875, 127438357882, 127438357899, 127438357905, 127438357912, 127438357929\n\nBuddha Symbol Meaning\n\nHotei brings Wisdom, Abundance, and Fulfillment.\n\nWARNING: Color may vary (darker or lighter)\n\nMaterial: Resin\nHeight in Inches: 1.5" to 2.5"',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:43.064Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
